import React, { useState } from "react";
import "./CMEndToEndSolutions.css";

const EndToEndSolutions = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const steps = [
    {
      title: "Step 1: Strategic Land & Energy Planning",
      content:
        "We start with a thorough feasibility analysis, site identification, and regulatory approvals. Our team designs a tailored strategy combining land development and renewable energy planning, ensuring legal compliance, sustainability, and optimal performance.",
      color: "#3A954F",
    },
    {
      title: "Step 2: Turnkey Project Execution",
      content:
        "Using our integrated resources, we manage procurement, civil works, and installation of all critical infrastructure, including solar arrays, electrical systems, and supporting facilities—ensuring timely, high-quality, and safe project delivery.",
      color: "#086D36",
    },
    {
      title: "Step 3: Commissioning & Long-Term Support",
      content:
        "We commission each project, connect it to the grid, and conduct rigorous testing. Our ongoing Operations & Maintenance services ensure sustained performance, reliability, and maximum long-term value for all stakeholders.",
      color: "#A1CB3A",
    },
  ];

  return (
    <section className="ees-section-cmabout">
      <div className="ees-container-cmabout">
        {/* LEFT TEXT */}
        <div className="ees-left-cmabout">
          <h2 className="ees-title-cmabout">
            ⚡ How CM Group's <br /> End-to-End <br /> Solutions Work
          </h2>
          <p className="ees-desc-cmabout">
            CM Group of Companies delivers integrated land and renewable energy solutions,
            simplifying complex projects into three strategic phases for maximum impact
            and sustainability.
          </p>
        </div>

        {/* RIGHT ACCORDION */}
        <div className="ees-right-cmabout">
          {steps.map((step, index) => (
            <div
              key={index}
              className="ees-card-cmabout"
              style={{ backgroundColor: step.color }}
            >
              <div
                className="ees-card-header-cmabout"
                onClick={() => toggle(index)}
              >
                <h3>{step.title}</h3>

                <span
                  className={
                    openIndex === index
                      ? "ees-arrow rotate-cmabout"
                      : "ees-arrow-cmabout"
                  }
                >
                  ^
                </span>
              </div>

              <div className={`ees-card-body-cmabout ${openIndex === index ? "open" : ""}`}>
                <p>{step.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EndToEndSolutions;
